// BulkEditMemberFields.js
import React, { useState } from "react";
import {
  Button,
  Grid,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@mui/material";
import { useFieldArray } from "react-hook-form";
import Iconify from "../iconify";
import SelectField from "../form/fields/SelectField";
import { anredeArray, gradArray } from "../form/fields/inputFields";
import DEDateField from "../form/fields/DEDateField";
import TextField from "../form/fields/TextField";
import { SiteSelectHookFormField } from "../form/fields/SiteSelectHookFormField";

const BulkEditMemberFields = ({ control }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "editItems",
  });

  const [selectedField, setSelectedField] = useState("");

  const allFields = [
    {
      value: "title",
      label: "Anrede",
      component: SelectField,
      props: { itemArray: anredeArray },
    },
    {
      value: "degree",
      label: "Gürtelgrad",
      component: SelectField,
      props: { itemArray: gradArray },
    },
    { value: "birthdate", label: "Geburtsdatum", component: DEDateField },
    { value: "contractDate", label: "Vertragsdatum", component: DEDateField },
    {
      value: "contractDuration",
      label: "Vertragslaufzeit",
      component: TextField,
      props: { type: "number", endAdornment: "Monate" },
    },
    {
      value: "contractExtension",
      label: "Vertragsverlängerung",
      component: TextField,
      props: { type: "number", endAdornment: "Monate" },
    },
    {
      value: "noticePeriod",
      label: "Kündigungsfrist",
      component: TextField,
      props: { type: "number", endAdornment: "Monate" },
    },
    {
      value: "contribution",
      label: "Mitgliedsbeitrag (€)",
      component: TextField,
      props: { type: "number" },
    },
    { value: "lastTesting", label: "Letzte Prüfung", component: DEDateField },
    { value: "email", label: "E-Mail", component: TextField },
    { value: "firstName", label: "Vorname", component: TextField },
    { value: "lastName", label: "Nachname", component: TextField },
    {
      value: "standortRef",
      label: "Standort",
      component: SiteSelectHookFormField,
    },
  ];

  const availableFields = allFields.filter(
    (field) => !fields.some((item) => item.field === field.value)
  );

  const handleAddField = () => {
    if (selectedField) {
      append({ field: selectedField });
      setSelectedField("");
    }
  };

  return (
    <Paper elevation={0} sx={{ minWidth: { xs: "200px", lg: 800 }, p: 2 }}>
      <Grid container spacing={2}>
        {fields.map((item, index) => {
          const fieldMeta = allFields.find((f) => f.value === item.field);
          const FieldComponent = fieldMeta?.component;

          return (
            <React.Fragment key={item.id}>
              <Grid item xs={12} md={10}>
                <Typography variant="h6">{fieldMeta.label}</Typography>
                <FieldComponent
                  control={control}
                  name={fieldMeta.value}
                  {...(fieldMeta.props || {})}
                />
              </Grid>
              <Grid item xs={12} md={2} sx={{ mt: 4 }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => remove(index)}
                >
                  <Iconify icon="mdi:delete" />
                </Button>
              </Grid>
            </React.Fragment>
          );
        })}
        <Grid item xs={12} md={8}>
          <Select
            value={selectedField}
            onChange={(e) => setSelectedField(e.target.value)}
            displayEmpty
            fullWidth
            disabled={availableFields.length === 0}
          >
            <MenuItem value="" disabled>
              Feld auswählen
            </MenuItem>
            {availableFields.map(({ value, label }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} md={4}>
          <Button
            variant="contained"
            fullWidth
            onClick={handleAddField}
            disabled={!selectedField}
          >
            Feld hinzufügen
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BulkEditMemberFields;
